import { styled } from '@mui/material/styles';
import { Paper, Box, Button, Typography } from '@mui/material';

// Root Paper container for the timer panel
export const Root = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
  background: 'linear-gradient(145deg, rgba(12,18,32,0.9), rgba(34,211,238,0.06))',
  border: `1px solid ${theme.palette.primary.main}33`,
  boxShadow: theme.shadows[14],
  // Responsive max height
  [theme.breakpoints.up('lg')]: {
    maxHeight: 650,
  },
  [theme.breakpoints.up('xl')]: {
    maxHeight: 'none',
  },
  overflow: 'hidden',
}));

// Circular container for session timer, positions relative for ripple effect
export const CircleContainer = styled(Box, { shouldForwardProp: (prop) => prop !== 'isLargeScreen' })(
  ({ theme, isLargeScreen }) => ({
    position: 'relative',
    width: isLargeScreen ? 200 : 150,
    height: isLargeScreen ? 200 : 150,
    borderRadius: '50%',
    border: `1px solid ${theme.palette.primary.main}55`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'radial-gradient(circle, rgba(34,211,238,0.12), rgba(14,165,233,0.05))',
    overflow: 'visible',
    boxShadow: '0 20px 50px rgba(0,0,0,0.35)',
  })
);

// Styled Button for start/stop with top margin and max width
export const StartStopButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '100%',
  maxWidth: 260,
  fontWeight: 800,
}));

// Styled component for the ripple effect on standing
export const Ripple = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  animation: 'ripple 1.5s infinite ease-in-out',
  border: `2px solid ${theme.palette.primary.light}`,
  '@keyframes ripple': {
    '0%': { transform: 'scale(1)', opacity: 0.5 },
    '100%': { transform: 'scale(1.5)', opacity: 0 },
  },
}));

export const WelcomeText = styled(Typography)(({ theme }) => ({
  width: '100%',
  textAlign: 'center',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  // Responsive font sizes AND max widths
  fontSize: '2.125rem',
  background: theme.customGradients?.brand,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem',
    maxWidth: '250px',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: '1.75rem',
    maxWidth: '350px',
  },
  [theme.breakpoints.between('md', 'lg')]: {
    fontSize: '2rem',
    maxWidth: '450px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '2.125rem',
    maxWidth: '700px',
  },
}));
